import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '../core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const trackPreferencesFiltersDrawerOpenedAnalytics = (payload: TrackingPayload) => {
    track(TrackingEvents.SearchPage.PreferencesFiltersDrawerOpened, payload);
};

export const useTrackPreferencesFiltersDrawerOpened = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        return trackPreferencesFiltersDrawerOpenedAnalytics({
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [pathname, url]);
};
